<template>
    <div class="page-nav">
        <div class="page-nav-list">
            <ul>
                <li 
                v-for="(nav, key) in navs" :key="key"
                :class="{'active-nav': checkName(nav.name)}"
                @click="navClick(nav)">
                    <div class="parent-menu">
                        <router-link :to="nav.router">{{nav.txt}}</router-link>
                        <div class="child-menu" v-if="nav.childrens">
                            <ul>
                                <li
                                v-for="children in nav.childrens" :key="children.txt">
                                    <router-link :to="children.router">{{children.txt}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageNav',
    data() {
        return  {
            navs: [
                {
                    txt: '实时数据',
                    name: 'PagesControl',
                    router: '/batt-list/real-time'
                },
                {
                    txt: '历史数据',
                    name: 'PagesHistory',
                    router: '/batt-list/history',
                },
                {
                    txt: '工作日志',
                    router: ''
                },
                {
                    txt: '用户管理',
                    name: 'PagesUser',
                    router: '',
                    childrens: [
                        {
                            txt: '用户信息管理',
                            name: 'UserInfo',
                            router: '/user/info',
                        },
                        {
                            txt: '用户权限管理',
                            name: 'UserPower',
                            router: '/user/power',
                        },
                        {
                            txt: '包机组管理',
                            name: 'UserBaoji',
                            router: '/user/baoji',
                        },
                    ],
                },
                {
                    txt: '文件导出',
                    router: '',
                }
            ],
        }
    },
    methods: {
        navClick: function(data) {
            // 已经激活
            if(data.active) {
                return;
            }
            // 导航激活状态
            this.$store.dispatch('changeNavName', data.name);
            // 面包导航条
            this.$store.dispatch('changeCrumb', {
                txt: data.txt,
				index: 0,
				cutOut: false,
            });
        },
        checkName: function(name) {
            if(name) {
                var navName = this.$store.state.navName;
                return navName.indexOf(name) == -1?false:true;
            }
            return false;
            
        }
    }
}
</script>
<style scoped>
.page-nav {
    background-color: none; /* 浏览器不支持时显示 */
    border-radius: 0.08rem;
    background-image: linear-gradient(#49DFED, #016A95,#00638D, #006999, #009EE3);
    font-size: 0.15rem;
    text-align: center;
}
.page-nav::after {
    clear: both;
    content: "";
    display: block;
    width: 0;
    height: 0;
}
.page-nav-list>ul {
    display: flex;
    justify-content: space-around;
}
.page-nav-list>ul>li {
    flex:1;
}
.page-nav-list>ul>li:hover {
    background-color: #12c4d1;
}
.page-nav-list>ul>li.active-nav {
    background-color: #15E3F3;
}
.parent-menu {
    position: relative;
}
.parent-menu ul {
    margin-top: -4px;
}
.parent-menu>a {
    display: block;
    text-align: center;
    min-width: 1rem;
    line-height: 0.38rem;
    padding-left: 0.18rem;
    padding-right: 0.18rem;
}

.child-menu {
    display: none;
    position: absolute;
    min-width: 100%;
    z-index: 99;
    border-bottom: 1px solid #ccc;
}
.child-menu ul {
    margin-top: 0.1rem;
}
.child-menu li {
    background-color: #FFFFFF;
    border-top: 1px solid #ccc;
}
.child-menu li:first-child {
    position: relative;
}
.child-menu li:first-child::before {
    position: absolute;
    top: -0.1rem;
    display: inline-block;
    content: '';
    width: 0;
    height: 0;
    border-left: 0.05rem solid transparent;
    border-right: 0.05rem solid transparent;
    border-bottom: 0.1rem solid #FFFFFF;
}
.child-menu a {
    display: block;
    text-align: center;
    min-width: 100%;
    line-height: 0.38rem;
    white-space: nowrap;
    color: #000000;
}
.child-menu li:hover{
    background-color: #f1f1f1;
}
/* 显示下拉框 */
.parent-menu:hover .child-menu {
    display: block;
}
</style>


